import { gql } from '@apollo/client';

export const orderHealthcareQueryApollo = gql`
  mutation OrderHealthCare(
    $comparisonId: String!
    $chosenProductKrn: String!
    $frontEndName: String
    $policy: Any!
    $sessionId: String!
    $clientId: String!
    $googleAnalyticsId: String
    $googleAnalyticsSessionId: String
    $gclid: String
    $fbp: String
    $fbc: String
    $vwoId: String
  ) {
    orderHealthCare(
      input: {
        comparisonId: $comparisonId
        chosenProductKrn: $chosenProductKrn
        frontEndName: $frontEndName
        input: {
          policyPolicyDetails: [$policy]
          commonTechnical: {
            sessionId: $sessionId
            senderId: $clientId
            googleAnalyticsId: $googleAnalyticsId
            googleAnalyticsSessionId: $googleAnalyticsSessionId
            gclid: $gclid
            fbp: $fbp
            fbc: $fbc
            vwoId: $vwoId
          }
        }
      }
    ) {
      healthCare_Result {
        orderId
        errors
      }
      errors {
        ... on HealthCare_NotAuthorizedError {
          type
          message
          clientId
          productKrn
        }
        ... on HealthCare_ProductNotFoundError {
          type
          message
          productKrn
        }
        ... on HealthCare_InvalidClientError {
          type
          message
          code
        }
        ... on HealthCare_IGraphQlErrorBase {
          type
          message
        }
      }
    }
  }
`;
